import { render, staticRenderFns } from "./AppAutoCompleteNew.vue?vue&type=template&id=036b0a48&scoped=true&"
import script from "./AppAutoCompleteNew.vue?vue&type=script&lang=js&"
export * from "./AppAutoCompleteNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b0a48",
  null
  
)

export default component.exports